import ConfigurationService from '../Service/ConfigurationService';
import { RequestConfig, Role, Roles } from 'tree-wallet-client';
import { requestOrThrow } from '../Helper/Http';
import { getRoleFromArray, arrayHasRole } from '../Service/RoleService';

export const UserTypes = {
  Individual: 'INDIVIDUAL',
  Company: 'COMPANY',
}

const userRoles: Roles = {
  User: {
    label: 'user',
    name: 'ROLE_USER'
  },
  CompensationProgram: {
    label: 'compensation program',
    name: 'ROLE_COMPENSATION_PROGRAM'
  },
  Admin: {
    label: 'admin',
    name: 'ROLE_ADMIN'
  },
};

export const UserRoles: Roles = {
  ...userRoles,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  all: { ...userRoles }
};

export function userHasRole(userRoles: string[], targetRole: string): boolean {
  return arrayHasRole(userRoles, targetRole);
}

export function getRole(targetRole: string): Role|undefined {
  return getRoleFromArray(targetRole, Object.values(userRoles));
}

export async function getUser(config?: RequestConfig) {
  const { params } = config || {};

  const url = params && params.userId
    ? `${ConfigurationService.urls().getUserInfosUrl}/${params.userId}`
    : ConfigurationService.urls().getMyUserInfosUrl;

  return await requestOrThrow(url, {
    ...config,
    ...{ cache: true }
  });
}

export async function updateUser(userId: any, data: FormData, config?: RequestConfig) {
  return await requestOrThrow(
    `${ConfigurationService.urls().updateUserInfosUrl}/${userId}`,
    { ...[config ? config : {}], httpConfig: {
      multipart: true,
      method: 'POST',
      body: data
    } }
  );
}

export async function createUser(data: FormData, config?: RequestConfig) {
  return await requestOrThrow(
    `${ConfigurationService.urls().createUserUrl}`,
    { ...[config ? config : {}], httpConfig: {
      multipart: true,
      method: 'POST',
      body: data
    } }
  );
}

export async function getUsersList(config: RequestConfig) {
  const { params } = config;

  const url = params && params.contractId
    ? `${ConfigurationService.urls().userListUrl}/${params.contractId}`
    : ConfigurationService.urls().userListUrl;

  return await requestOrThrow(url, config);
}

export async function getAdminUsersList(config: RequestConfig) {
  const { params } = config;
  const contractId = params?.contractId;
  let url = ConfigurationService.urls().adminUserListUrl;
  url = url + (contractId ? `/${contractId}` : '');
  url = params?.filters ? `${url}?filters=${params?.filters}` : url;
  return requestOrThrow(url, config);
}
